import { ErrorMessage } from '@doordash/component-fields'
import { InlineChildren, Text } from '@doordash/design-language'
import * as React from 'react'

import styled from 'styled-components'

import { Birthdate } from './styles'

import t from './strings'

const ErrorWrapper = styled.div`
  margin-top: 4px !important;
`

type Props = {
  onChange: (any) => void
  id: string
  label: string
  value?: string
  touched?: boolean
  error?: string
  minBirthday?: string
}

export class BirthdateInput extends React.Component<Props> {
  public handleChange = event => {
    this.props.onChange(event.target.value)
  }

  public render() {
    const { minBirthday, error, id } = this.props
    return (
      <React.Fragment>
        <InlineChildren
          justifyContent={InlineChildren.Justification.SpaceBetween}
        >
          <Text tag="label" styles={Text.Styles.Medium14} htmlFor={id}>
            {t.birthdate()}
          </Text>
          <Text
            tag="label"
            styles={Text.Styles.Medium14}
            htmlFor={id}
            color={Text.Colors.Tertiary}
          >
            {t.required()}
          </Text>
        </InlineChildren>
        <Birthdate
          type="date"
          id={id}
          onChange={event => this.handleChange(event)}
          max={minBirthday || ''}
          data-error={error}
        />
        {error && (
          <ErrorWrapper>
            <ErrorMessage error={error} />
          </ErrorWrapper>
        )}
      </React.Fragment>
    )
  }
}

export default BirthdateInput
